import { css } from 'aphrodite';
import { SendEmailFrom } from '../../../extViewmodels';
import { DeprecatedTextArea } from '../../components/DeprecatedTextArea';
import { styleSheet } from './styles';

export const cardSignaturePlaceholderText = '[Signature will be included here]';
export const allowedSendersForSignatureEditing = [SendEmailFrom.CurrentUser, SendEmailFrom.SelectedUser];

export function BulkHwcSignatureField({
	signature,
	disabled,
	onChange,
}: {
	signature?: string;
	disabled?: boolean;
	onChange: (value: string) => void;
}) {
	return (
		<div className={css(styleSheet.configDrawerSection)}>
			<h4 className={css(styleSheet.configDrawerSelectSig)}>Signature</h4>
			<DeprecatedTextArea
				disabled={disabled}
				inputId='postcard-signature'
				value={disabled ? cardSignaturePlaceholderText : signature}
				onChange={ev => onChange(ev.target.value)}
			/>
		</div>
	);
}
